import { render, staticRenderFns } from "./ScoreQuestion.vue?vue&type=template&id=31a0bc81&scoped=true"
import script from "./ScoreQuestion.vue?vue&type=script&lang=js"
export * from "./ScoreQuestion.vue?vue&type=script&lang=js"
import style0 from "./ScoreQuestion.vue?vue&type=style&index=0&id=31a0bc81&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31a0bc81",
  null
  
)

export default component.exports